import React, { useState } from 'react';
import './TooltipComponent.css';
import Tooltip from '@material-ui/core/Tooltip';
import {
  IonIcon,
  IonText,
} from '@ionic/react';
import { isMobile } from '../../helpers/Utils';
import { Box } from '@material-ui/core';

interface TooltipComponentProps {
  icon?: string;
  title?: string;
  body?: string;
  message?: string;
  className?: string;
  titleColor?: string;
}

const TooltipComponent: React.FC<TooltipComponentProps> = ({ icon, title, body, message, className, titleColor }) => {

  const [showTooltip, setShowTooltip] = useState<boolean>(false)

  const toggleTooltip = () => {
    return (!showTooltip) ? setShowTooltip(true) : setShowTooltip(false);
  }

  return (
    <>
      <Tooltip
        placement="top"
        open={showTooltip}
        onOpen={() => setShowTooltip(true)}
        onClose={() => setShowTooltip(false)}
        title={<Box className='tooltip--text'>{message}</Box>}>
        <IonText className={className || ''}><b><span className={titleColor}>{title}</span> <IonIcon onClick={toggleTooltip} onMouseEnter={isMobile() ? () => (false) : () => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} icon={icon} class="tooltip" color={(!showTooltip) ? 'tooltip' : 'primary'}></IonIcon></b>{body}</IonText>
      </Tooltip>
    </>
  );
};

export default TooltipComponent;
